// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimDocumentDTO } from '../models';
import { CreateClaimDocumentByDocumentIdDTO } from '../models';
/**
 * ClaimDocumentsApi - axios parameter creator
 * @export
 */
export const ClaimDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Attach a Document to a Claim
         * @param {string} claimId Claim id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimDocument(claimId: string, file: any, name: string, type: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling addClaimDocument.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling addClaimDocument.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling addClaimDocument.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling addClaimDocument.');
            }
            const localVarPath = `/v2/claims/{claimId}/documents`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Attach a Document to a Claim by passing a document id
         * @param {string} claimId Claim id
         * @param {CreateClaimDocumentByDocumentIdDTO} createClaimDocumentByDocumentIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimDocumentByDocumentId(claimId: string, createClaimDocumentByDocumentIdDTO: CreateClaimDocumentByDocumentIdDTO, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling addClaimDocumentByDocumentId.');
            }
            // verify required parameter 'createClaimDocumentByDocumentIdDTO' is not null or undefined
            if (createClaimDocumentByDocumentIdDTO === null || createClaimDocumentByDocumentIdDTO === undefined) {
                throw new RequiredError('createClaimDocumentByDocumentIdDTO','Required parameter createClaimDocumentByDocumentIdDTO was null or undefined when calling addClaimDocumentByDocumentId.');
            }
            const localVarPath = `/v2/claims/{claimId}/documents/by-document-id`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateClaimDocumentByDocumentIdDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createClaimDocumentByDocumentIdDTO !== undefined ? createClaimDocumentByDocumentIdDTO : {}) : (createClaimDocumentByDocumentIdDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Claim Document
         * @param {string} claimId Claim id
         * @param {string} documentId Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimDocument(claimId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deleteClaimDocument.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling deleteClaimDocument.');
            }
            const localVarPath = `/v2/claims/{claimId}/documents/{documentId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Claim Document by id
         * @param {string} claimId  Claim id
         * @param {string} documentId Claim Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimDocumentById(claimId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findClaimDocumentById.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling findClaimDocumentById.');
            }
            const localVarPath = `/v2/claims/{claimId}/documents/{documentId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Claim Documents by for a Claim by id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimDocuments(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findManyClaimDocuments.');
            }
            const localVarPath = `/v2/claims/{claimId}/documents`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimDocumentsApi - functional programming interface
 * @export
 */
export const ClaimDocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Attach a Document to a Claim
         * @param {string} claimId Claim id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimDocument(claimId: string, file: any, name: string, type: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDocumentDTO> {
            const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).addClaimDocument(claimId, file, name, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Attach a Document to a Claim by passing a document id
         * @param {string} claimId Claim id
         * @param {CreateClaimDocumentByDocumentIdDTO} createClaimDocumentByDocumentIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimDocumentByDocumentId(claimId: string, createClaimDocumentByDocumentIdDTO: CreateClaimDocumentByDocumentIdDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDocumentDTO> {
            const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).addClaimDocumentByDocumentId(claimId, createClaimDocumentByDocumentIdDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete Claim Document
         * @param {string} claimId Claim id
         * @param {string} documentId Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimDocument(claimId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).deleteClaimDocument(claimId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Claim Document by id
         * @param {string} claimId  Claim id
         * @param {string} documentId Claim Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimDocumentById(claimId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimDocumentDTO> {
            const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).findClaimDocumentById(claimId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all Claim Documents by for a Claim by id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimDocuments(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimDocumentDTO>> {
            const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).findManyClaimDocuments(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimDocumentsApi - factory interface
 * @export
 */
export const ClaimDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Attach a Document to a Claim
         * @param {string} claimId Claim id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimDocument(claimId: string, file: any, name: string, type: string, options?: any) {
            return ClaimDocumentsApiFp(configuration).addClaimDocument(claimId, file, name, type, options)(axios, basePath);
        },
        /**
         * Attach a Document to a Claim by passing a document id
         * @param {string} claimId Claim id
         * @param {CreateClaimDocumentByDocumentIdDTO} createClaimDocumentByDocumentIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimDocumentByDocumentId(claimId: string, createClaimDocumentByDocumentIdDTO: CreateClaimDocumentByDocumentIdDTO, options?: any) {
            return ClaimDocumentsApiFp(configuration).addClaimDocumentByDocumentId(claimId, createClaimDocumentByDocumentIdDTO, options)(axios, basePath);
        },
        /**
         * Delete Claim Document
         * @param {string} claimId Claim id
         * @param {string} documentId Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimDocument(claimId: string, documentId: string, options?: any) {
            return ClaimDocumentsApiFp(configuration).deleteClaimDocument(claimId, documentId, options)(axios, basePath);
        },
        /**
         * Get a Claim Document by id
         * @param {string} claimId  Claim id
         * @param {string} documentId Claim Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimDocumentById(claimId: string, documentId: string, options?: any) {
            return ClaimDocumentsApiFp(configuration).findClaimDocumentById(claimId, documentId, options)(axios, basePath);
        },
        /**
         * Get all Claim Documents by for a Claim by id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimDocuments(claimId: string, options?: any) {
            return ClaimDocumentsApiFp(configuration).findManyClaimDocuments(claimId, options)(axios, basePath);
        },
    };
};

/**
 * ClaimDocumentsApi - interface
 * @export
 * @interface ClaimDocumentsApi
 */
export interface ClaimDocumentsApiInterface {
    /**
     * Attach a Document to a Claim
     * @param {string} claimId Claim id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApiInterface
     */
    addClaimDocument(claimId: string, file: any, name: string, type: string, options?: any): AxiosPromise<ClaimDocumentDTO>;

    /**
     * Attach a Document to a Claim by passing a document id
     * @param {string} claimId Claim id
     * @param {CreateClaimDocumentByDocumentIdDTO} createClaimDocumentByDocumentIdDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApiInterface
     */
    addClaimDocumentByDocumentId(claimId: string, createClaimDocumentByDocumentIdDTO: CreateClaimDocumentByDocumentIdDTO, options?: any): AxiosPromise<ClaimDocumentDTO>;

    /**
     * Delete Claim Document
     * @param {string} claimId Claim id
     * @param {string} documentId Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApiInterface
     */
    deleteClaimDocument(claimId: string, documentId: string, options?: any): AxiosPromise<{}>;

    /**
     * Get a Claim Document by id
     * @param {string} claimId  Claim id
     * @param {string} documentId Claim Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApiInterface
     */
    findClaimDocumentById(claimId: string, documentId: string, options?: any): AxiosPromise<ClaimDocumentDTO>;

    /**
     * Get all Claim Documents by for a Claim by id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApiInterface
     */
    findManyClaimDocuments(claimId: string, options?: any): AxiosPromise<Array<ClaimDocumentDTO>>;

}

/**
 * ClaimDocumentsApi - object-oriented interface
 * @export
 * @class ClaimDocumentsApi
 * @extends {BaseAPI}
 */
export class ClaimDocumentsApi extends BaseAPI implements ClaimDocumentsApiInterface {
    /**
     * Attach a Document to a Claim
     * @param {string} claimId Claim id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApi
     */
    public addClaimDocument(claimId: string, file: any, name: string, type: string, options?: any) {
        return ClaimDocumentsApiFp(this.configuration).addClaimDocument(claimId, file, name, type, options)(this.axios, this.basePath);
    }

    /**
     * Attach a Document to a Claim by passing a document id
     * @param {string} claimId Claim id
     * @param {CreateClaimDocumentByDocumentIdDTO} createClaimDocumentByDocumentIdDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApi
     */
    public addClaimDocumentByDocumentId(claimId: string, createClaimDocumentByDocumentIdDTO: CreateClaimDocumentByDocumentIdDTO, options?: any) {
        return ClaimDocumentsApiFp(this.configuration).addClaimDocumentByDocumentId(claimId, createClaimDocumentByDocumentIdDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete Claim Document
     * @param {string} claimId Claim id
     * @param {string} documentId Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApi
     */
    public deleteClaimDocument(claimId: string, documentId: string, options?: any) {
        return ClaimDocumentsApiFp(this.configuration).deleteClaimDocument(claimId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get a Claim Document by id
     * @param {string} claimId  Claim id
     * @param {string} documentId Claim Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApi
     */
    public findClaimDocumentById(claimId: string, documentId: string, options?: any) {
        return ClaimDocumentsApiFp(this.configuration).findClaimDocumentById(claimId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get all Claim Documents by for a Claim by id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimDocumentsApi
     */
    public findManyClaimDocuments(claimId: string, options?: any) {
        return ClaimDocumentsApiFp(this.configuration).findManyClaimDocuments(claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimDocumentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Attach a Document to a Claim
 * @param {string} claimId Claim id
 * @param {any} file 
 * @param {string} name 
 * @param {string} type 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addClaimDocument(
    claimId: string,
    file: any,
    name: string,
    type: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDocumentDTO> {
    const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).addClaimDocument(claimId, file, name, type, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Attach a Document to a Claim by passing a document id
 * @param {string} claimId Claim id
 * @param {CreateClaimDocumentByDocumentIdDTO} createClaimDocumentByDocumentIdDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addClaimDocumentByDocumentId(
    claimId: string,
    createClaimDocumentByDocumentIdDTO: CreateClaimDocumentByDocumentIdDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDocumentDTO> {
    const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).addClaimDocumentByDocumentId(claimId, createClaimDocumentByDocumentIdDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete Claim Document
 * @param {string} claimId Claim id
 * @param {string} documentId Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteClaimDocument(
    claimId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).deleteClaimDocument(claimId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Claim Document by id
 * @param {string} claimId  Claim id
 * @param {string} documentId Claim Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findClaimDocumentById(
    claimId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimDocumentDTO> {
    const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).findClaimDocumentById(claimId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get all Claim Documents by for a Claim by id
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findManyClaimDocuments(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<ClaimDocumentDTO>> {
    const localVarAxiosArgs = ClaimDocumentsApiAxiosParamCreator(configuration).findManyClaimDocuments(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

